module.exports = __webpack_public_path__ + "static/media/plumbing-1103725_1920_2.62d02fb6.jpg";